import { createContext } from "react";

export interface Config {
  arcgisURL: string;
  oauth: {
    server: string;
    clientId: string;
    redirectURL: string;
  };
  baseURL: string;
}

export const configContext = createContext<Config>({
  oauth: {
    server: "",
    clientId: "",
    redirectURL: "",
  },
  baseURL: "",
  arcgisURL: "",
});
